import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import CategoryWidget from "./CategoryWidget";
import { KBContext } from "../../Context";
import { useCategories } from "../../hooks/apis/useCategories";
import { Link, useLocation } from "react-router-dom";
import nocatImage from "../../images/nocatImage.svg";
import ScrollToTop from "../../Components/ScrollToTop";
import { handlePageVisitData } from "../../utils";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

/* Grid: uniform card sizes, gutters 24–32px */
const CategoryGrid = styled.div`
  display: grid;
  gap: 24px;
  padding-top: 32px;
  grid-template-columns: ${(props) =>
    props.categoryCound === 1
      ? "1fr"
      : props.categoryCound === 2
      ? "repeat(2, 1fr)"
      : props.categoryCound >= 3
      ? "repeat(3, 1fr)"
      : ""};
  align-items: stretch;
  margin-bottom: 60px;
  width: 100%;
  max-width: 100%;

  @media (max-width: 1258px) {
    grid-template-columns: ${(props) =>
      props.categoryCound === 1 ? "1fr" : "repeat(2, 1fr)"};
  }

  @media screen and (max-width: 1100px) {
    margin: 0 0 48px 0;
  }

  @media screen and (max-width: 800px) {
    margin: 0 0 48px 0;
    grid-template-columns: 1fr;
  }

  @media screen and (max-width: 500px) {
    margin: 0 0 40px 0;
    grid-template-columns: 1fr;
  }
`;

const GridLink = styled(Link)`
  display: block;
  height: 100%;
  text-decoration: none;
`;

const CategoryNotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const CategoryNotFoundImage = styled.img`
  width: 132px;
  height: 101.82px;
  margin-bottom: 10px;
`;

export default function CategoryHome() {
  const { data: categoryList } = useCategories(); 
  const { data, data: { isInternal } } = useContext(KBContext);
  const { search, pathname } = useLocation();

  useEffect(() => {
    handlePageVisitData(globalThis.location, isInternal);
    document.getElementById("mainWrapper")?.focus();
  }, [pathname, isInternal]);

  return (
    <Wrapper>
      <ScrollToTop />
      {categoryList?.length === 0 && (
        <CategoryNotFoundWrapper>
          <CategoryNotFoundImage src={nocatImage} />
          There are no published categories or articles
        </CategoryNotFoundWrapper>
      )}
      <CategoryGrid categoryCound={categoryList?.length}>
        {categoryList?.map((category) => (
            <GridLink
              key={category.slug}
              to={`/${category.slug}` + search}
            >
              <CategoryWidget
                color={data?.brandColor}
                icon={category?.icon}
                title={category.title}
                description={category.description}
                immediateSubcategoryCount={category.immediateSubcategoryCount}
                immediateArticleCount={category.immediateArticleCount}
              />
            </GridLink>
        ))}
      </CategoryGrid>
    </Wrapper>
  );
}
